export interface TimeOptionsInterface {
	HOUR_STEP?: number;
	MINUTE_STEP?: number;
	SECOND_STEP?: number;
	SHOW_MINUTES?: boolean;
	SHOW_SECONDS?: boolean;
	IS_UTC?: boolean;
}

export class TimeOptions implements TimeOptionsInterface {
	public HOUR_STEP = 1;
	public MINUTE_STEP = 30;
	public SECOND_STEP = 30;
	public SHOW_MINUTES = true;
	public SHOW_SECONDS = false;
	public IS_UTC = false;

	constructor(timeOptions?: TimeOptionsInterface) {
		if (timeOptions == null) {
			return;
		}

		if (!!timeOptions.HOUR_STEP) {
			this.HOUR_STEP = timeOptions.HOUR_STEP;
		}

		if (!!timeOptions.MINUTE_STEP) {
			this.MINUTE_STEP = timeOptions.MINUTE_STEP;
		}

		if (!!timeOptions.SECOND_STEP) {
			this.SECOND_STEP = timeOptions.SECOND_STEP;
		}

		if (!!timeOptions.SHOW_MINUTES) {
			this.SHOW_MINUTES = timeOptions.SHOW_MINUTES;
		}

		if (!!timeOptions.SHOW_SECONDS) {
			this.SHOW_SECONDS = timeOptions.SHOW_SECONDS;
		}

		if (!!timeOptions.IS_UTC) {
			this.IS_UTC = timeOptions.IS_UTC;
		}
	}
}
